import { IPlatform } from "../entity/platforms/IPlatform";

export const prepareRequestBody = (app: IPlatform) => {
  const {minimal_version: min, recommended_version: rec, link} = app;
  return app.name === 'Android' ? 
    { minAndroidVersion: min, recommendedAndroidVersion: rec, storeLinks: { android: link } } :
    { minIosVersion: min, recommendedIosVersion: rec, storeLinks: { IOS: link } };
};